import { 
  Component, 
  Input, 
  ViewChild,
  AfterViewInit,
  ApplicationRef,
  ComponentFactoryResolver,
  Injector 
} from '@angular/core';

import { MyModule } from './my-module/my-module';
import { GridComponent } from 'source/app/controls/components/grid/grid-component';
import { ColumnGroup } from 'source/app/objects/request/column-group';
import { Dictionary } from 'source/app/objects/dictionary';
import { Column } from 'source/app/objects/request/column';
import { ColumnType } from 'source/app/objects/request/column-type';
import { GridLength } from 'source/app/objects/request/grid-length';
import { ColumnAggregate } from 'source/app/objects/request/column-aggregate';

@Component({
  templateUrl: './dev-playground.html'
})
export class DevPlaygroundComponent {
  @ViewChild(GridComponent) grid: GridComponent;
  ColumnGroups: Dictionary<ColumnGroup> = new Dictionary<ColumnGroup>();
  Columns: Dictionary<Column> = new Dictionary<Column>();
  Items: Array<any> = new Array<any>();
  TonsOfItems: Array<any> = new Array<any>();
  IsBusy: boolean;

  constructor() {
    var tonsOfItems = [];
    for (var i=0; i<100000; i++) {      
      tonsOfItems.push({ Name: "item " + i });
    }

    this.TonsOfItems = tonsOfItems;

    var columns = new Dictionary<Column>();
    for (var i=1; i<3; i++)
    {
      var name = String.fromCharCode(i + 64);
      //
      var column = new Column(name, name, i.toString(), ColumnType.Number, new GridLength(100), "center", "center", undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, "Column1");
      columns.add(name, column);
    }
    columns.add("Number", new Column("C", "C", "3", ColumnType.Number, new GridLength(100), "center", "center", undefined, undefined, undefined, undefined, undefined, true, undefined, ColumnAggregate.Sum, "Column2"));
    columns.add("Template", new Column("Template", "Template", undefined, ColumnType.String, new GridLength(100), "left", "left", "<my-module-component [Item]=\"Row['_rowHeight']\"></my-module-component>", "<div style=\"background-color: red\">Testing</div>", 1, [MyModule]));

    var rows = [];
    // for (var i=0; i<100; i++)
    for (var i=0; i<100; i++)
    {
      var row = {};

      for (var j=1; j<4; j++)
      {
        //row[j] = String.fromCharCode(j + 65) + "." + (i + 1);
        row[j.toString()] = j;
      }
      
      var items = [];
      for (var k=0; k<5; k++)
      {
        var child = {};
        for (var l = 1; l<4; l++) {
          //child[l] = "child" + String.fromCharCode(l + 65) + "." + (l + 1);
          child[l.toString()] = l;
        }
        items.push(child);
      }
      row["Items"] = items;
      rows.push(row);
    }

    this.ColumnGroups = new Dictionary<ColumnGroup>([
      { key: "Column1", value: new ColumnGroup("Column1", "hello 1") },
      { key: "Column2", value: new ColumnGroup("Column2", "hello 2") }
    ]);

    this.Columns = columns;
    this.Items = rows;
  }

  RowSize(row: any) {
    return Math.max(100-row['_rowNumber'] + 20, 20);
  }

  ToggleHighlightRow() {
    if (this.grid.SelectedRow)
      this.grid.ToggleHighlightRow(this.grid.SelectedRow);
  }

  ExportToExcel() {
    this.grid.ExportToExcel();
  }

  ToggleIsBusy() {
    this.IsBusy = !this.IsBusy;  
  }

  CollapseAll() {
    this.grid.CollapseAll();
  }

  ExpandAll() {
    this.grid.ExpandAll();
  }
 }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/dev-playground/dev-playground-component.ts